import { render, staticRenderFns } from "./BaskoBoxThankYou.vue?vue&type=template&id=e7cb4da6&"
import script from "./BaskoBoxThankYou.vue?vue&type=script&lang=js&"
export * from "./BaskoBoxThankYou.vue?vue&type=script&lang=js&"
import style0 from "./BaskoBoxThankYou.vue?vue&type=style&index=0&id=e7cb4da6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports